export const LINK_TO_HEALTH_TERMS = 'https://mantrahealth.com/terms-and-conditions';
export const LINK_TO_TELEHEALTH_CONSENT = 'https://mantrahealth.com/telehealth-consent';
export const LINK_TO_PRIVACY_POLICY = 'https://mantrahealth.com/privacy-policy';
